import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getReferentAutreTypeByUid(typeReferent, uid) {
    const response = await axios.get(
      "/api/gestion/" + typeReferent + "/autresReferents/" + uid
    );
    return response.data;
  },
  async getReferentsSuaio() {
    const response = await axios.get("/api/gestion/referentsSuaio");
    return response.data;
  },
  async notifierPresence(idEtudiant) {
    const response = await axios.post(
      "/api/suaio/etudiants/presence/" + idEtudiant
    );
    return response.data;
  },
  async notifierAtelier(idEtudiant) {
    const response = await axios.post(
      "/api/suaio/etudiants/atelier/" + idEtudiant
    );
    return response.data;
  },
};
